import React from 'react';
import { AddCircle, SelectTransaction, ValidationInput } from 'components';
import {
  EFS,
  FUEL,
  OFFICE_CHARGE,
  PREPAY_FEE,
  PROCESSING_REVERSAL,
  QUICKPAY,
  transactionType,
  TxnType,
} from './core/constants';
import { ErrorText, Images, useGlobalStyles } from 'utils';
import { inputsStyle } from '../../../components/inputs/styles';
import { CustomNumericFormat } from '../../../components/inputs/numbericFormat';

export const TransactionGroup = ({ inputs, setInputs, error, setError }) => {
  const globalStyles = useGlobalStyles();
  const classes = inputsStyle();
  const lastTransaction = inputs?.transactions?.[inputs?.transactions?.length - 1];
  const checkAmount = (type) => {
    return type === EFS || type === OFFICE_CHARGE || type === FUEL || type === PROCESSING_REVERSAL || type === QUICKPAY || type === PREPAY_FEE;
  };
  const handleChange = (e, index) => {
    const params = { ...inputs };
    params.transactions[index][e.target.name] = e.target.value;
    setInputs(params);
    error === e.target.name && setError('');
  };

  const addNewRow = () => {
    if (lastTransaction?.type && lastTransaction?.amount && lastTransaction?.qty) {
      const params = {
        ...inputs,
      };
      params.transactions.push({
        qty: 1,
        type: TxnType.INITIALRATE,
        amount: '',
        description: '',
      });
      setInputs(params);
    } else {
      setError(
        !lastTransaction.type ? 'type' :
          !lastTransaction.amount ? 'amount' :
            !lastTransaction.qty ? 'qty' : '',
      );
    }
  };

  return (
    <div>
      <div className="transactions-group-wrapper">
        {inputs?.transactions?.map((item, index) => {
          return <div className="transaction-row-box">
            <div className="transaction-type-input">
              <SelectTransaction
                className={ classes.inputTextField}
                style={globalStyles.simpleInputNoRight}
                name={'type'}
                label={'name'}
                title={'Transaction Type*'}
                handleSelect={(e) => handleChange(e, index)}
                defaultValue={item?.type}
                list={transactionType?.filter((i) => !i?.warn )}
                typeError={error === 'type' && index === inputs?.transactions?.length - 1 ? ErrorText.field : ''}
                error={error === 'type' && index === inputs?.transactions?.length - 1 ? 'type' : ''}
              />
            </div>
            <div className={'transaction-amount-input'}>
              <CustomNumericFormat
                errorName={error}
                error={error === 'amount' && index === inputs?.transactions?.length - 1 && ErrorText.field}
                label={'Amount*'}
                placeholder={'Amount*'}
                name={'amount'}
                value={item?.amount || '0'}
                handleChangeMiles={(e) =>  handleChange({
                  target:{
                    name: 'amount',
                    value: e.floatValue
                  }
                }, index)}
                // decimalScale={0}
              />
            </div>
            {(item?.type === PREPAY_FEE ? true : !checkAmount(item.type)) &&
              <div className="transaction-qty-input">
                <CustomNumericFormat
                  errorName={error}
                  error={error === 'qty' && index === inputs?.transactions?.length - 1 && ErrorText.field}
                  label={'Qty*'}
                  placeholder={'Qty*'}
                  name={'qty'}
                  value={item?.qty}
                  handleChangeMiles={(e) =>  handleChange({
                    target:{
                      name: 'qty',
                      value: e.floatValue
                    }
                  }, index)}
                  decimalScale={2}
                />
              </div>
            }
            <div className="transaction-total-box">
              <p>Total:</p>
              <span>$ {item?.amount && item?.qty ? (+item?.amount * +item?.qty).toFixed(2) : 0}</span>
            </div>
            <div className="transaction-desc-input">
              <ValidationInput
                // className={item.description && globalStyles.inputTextFieldBlue}
                style={globalStyles.simpleInputNoRight}
                onChange={(e) => handleChange(e, index)}
                value={item?.description}
                typeError={error === 'description' && ErrorText.field}
                label={'Description'}
                placeholder={'Description here...'}
                variant={'outlined'}
                name={'description'}
                Length={500}
                noErrMessage={true}
              />
              <div className="maximum-characters">
                Max 500 characters
              </div>
            </div>
            <button
              className="remove-transaction-button"
              style={{ opacity: inputs?.transactions?.length === 1 ? 0.5 : 1 }}
              disabled={inputs?.transactions?.length === 1}
              onClick={() => {
                const params = {
                  ...inputs,
                };
                params.transactions.splice(index, 1);
                setInputs(params);
              }}
            >
              <img src={Images.redTrash} alt="remove" />
            </button>
          </div>;
        })}
      </div>
      <div className="flex-end">
        <AddCircle
          handleCLic={addNewRow}
          text={'Add Transaction'}
        />
      </div>
    </div>
  );
};